import React, { useRef, useState } from 'react'
import styles from '../styles/vipDetails.module.scss'
import { useNavigate } from 'react-router-dom'
import VipRebateRate from './vipRebateRate'
import VipRules from './vipRules'
import { useTranslation } from 'react-i18next'
import VipBenefits from './vipBenefits'
import VipWithdrawalLimit from './vipWithdrawalLimit'
import { useGetGameFanshuiHighLow, useVipCfgList, useVipWeekInfo } from '../hooks/useVip'
import LoadingUI from '@/compoments/loadingUI'
import FadeIn from '@/compoments/fadeIn'
import Footer from '@/views/casino/compoment/footer'
import Icon from '@/wmCompoments/Icon'

const VipDetails = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('vip')

  // vip 返水比例
  const { data: rebate, isLoading: rebateLoading } = useGetGameFanshuiHighLow() || []
  // vip 福利
  const { data: vipWeek } = useVipWeekInfo()
  
  const { data: gradeData, isLoading: configLoading} = useVipCfgList()
  
  return (
    <FadeIn>
      <LoadingUI loading={rebateLoading} data={rebate} height={700}>
      <div className={styles.vipDetails}>
        {/* 顶部 */}
        <div className={styles.details_title}>
          <div>{t('vipDetails')}</div>
          <Icon name='icon-general-close' 
            onClick={() => navigate(-1)}
            className={styles.close}
          />
        </div>

        {/* vip返水比例 */}
        <VipRebateRate rebate={rebate} />

        {/* vip福利 */}
        <VipBenefits vipWeek={vipWeek} />

        {/* vip提款额度 */}
        <VipWithdrawalLimit gradeData={gradeData} />

        {/* vip规则 */}
        <VipRules />

      </div>

      {/* 页脚 */}
      <div className={styles.footer}>
        <Footer />
      </div>
      </LoadingUI>
    </FadeIn>
  )
}

export default VipDetails
